document.addEventListener('DOMContentLoaded', async function () {
  let allCities = [];
  let isShowingAll = false;
  let allCitiesPopulated = false;
  
  try {
    const myHeaders = new Headers();
    myHeaders.append("x-api-key", "KPwkS7MFb71KXrezuxUYJaf4EnFGvgkK9kgWaf7q");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };

    // Using the new API endpoint
    const response = await fetch(`https://api.thesleepcompany.in/stores`, requestOptions);
    const result = await response.json();
    
    // Check if the request was successful and data is available
    if (!result.success || !result.stores || !Array.isArray(result.stores)) {
      throw new Error('Invalid API response format');
    }
    
    const stores = result.stores;
    const cityCounts = {};
    const cityStoresMap = {};

    stores.forEach(store => {
      const city = store.city?.trim();
      if (!city || city.toLowerCase() === 'kerala') return;
      
      cityCounts[city] = (cityCounts[city] || 0) + 1;
      
      if (!cityStoresMap[city]) {
        cityStoresMap[city] = [];
      }
      cityStoresMap[city].push(store);
    });

    const sortedCities = Object.entries(cityCounts)
      .sort((a, b) => b[1] - a[1])
      .map(([city]) => city);

    allCities = sortedCities;

    window.cityStoresMap = cityStoresMap;
    window.cityCounts = cityCounts;

    loadCities(false);

    const viewAllBtn = document.getElementById('viewAllCitiesBtn');
    if (viewAllBtn) {
      viewAllBtn.addEventListener('click', function() {
        toggleCityView();
      });
    }

  } catch (error) {
    console.error('Error fetching cities:', error);
    const wrapper = document.querySelector('.store-other-city__wrapper');
    if (wrapper) {
      wrapper.innerHTML = '<p style="text-align: center; color: #666;">Unable to load cities at the moment.</p>';
    }
  }

  function attachCityClickHandlers() {
    const containerElement = document.querySelector('.store-other-city');
    const clickAction = containerElement?.dataset?.cityClickAction || 'redirect';
    
    // Only attach handlers if we're using search_stores mode
    if (clickAction === 'search_stores') {
      document.querySelectorAll('.dev_store-other-city__item a').forEach(cityLink => {
        cityLink.addEventListener('click', function(e) {
          e.preventDefault();
          
          const cityItem = this.closest('.dev_store-other-city__item');
          const pincode = cityItem.getAttribute('data-triggerpincode');
          const cityName = this.querySelector('.store-other-city__name').textContent.trim();
          const cityLink = cityItem.getAttribute('data-city-url');
          
          if (pincode) {
            const storeNearYouInput = document.getElementById('dev_snu-search-input');
            
            if (storeNearYouInput) {
              storeNearYouInput.value = pincode;
              localStorage.setItem("popupPincode", pincode);
              
              if (typeof fetchStoreData === 'function') {
                fetchStoreData(pincode, null, null);
              }
              
              const storeNearYouSection = document.querySelector('.snu-container');
              if (storeNearYouSection) {
                storeNearYouSection.scrollIntoView({ 
                  behavior: 'smooth',
                  block: 'start'
                });
              }
              
              storeNearYouInput.focus();
              storeNearYouInput.blur();
            } else {
              console.warn('Store-near-you input field not found. Redirecting to city page as fallback.');
              window.location.href = cityLink;
            }
          } else {
            console.warn(`No pincode found for city: ${cityName}. Redirecting to city page.`);
            window.location.href = cityLink;
          }
        });
      });
    }
  }

  function loadCities(showAll = false) {
    const citiesWrapper = document.querySelector('.store-other-city__wrapper');
    const allCitiesWrapper = document.querySelector('.store-other-city__all-cities');
    
    const containerElement = document.querySelector('.store-other-city');
    const desktopCount = parseInt(containerElement?.dataset?.initialCountDesktop) || 24;
    const mobileCount = parseInt(containerElement?.dataset?.initialCountMobile) || 12;
    
    const isMobile = window.innerWidth <= 768;
    const initialCount = isMobile ? mobileCount : desktopCount;
    
    if (showAll) {
      // Show the all cities wrapper
      citiesWrapper.style.display = 'none';
      
      // Only populate all cities once
      if (!allCitiesPopulated) {
        allCitiesWrapper.className = 'store-other-city__wrapper store-other-city__all-cities';
        allCitiesWrapper.innerHTML = '';
        allCities.forEach(city => {
          allCitiesWrapper.innerHTML += createCityHTML(city, window.cityStoresMap[city]);
        });
        allCitiesPopulated = true;
        
        setTimeout(() => {
          attachCityClickHandlers();
        }, 100);
      }
      
      allCitiesWrapper.style.display = 'grid';
    } else {
      // Show initial cities
      allCitiesWrapper.style.display = 'none';
      citiesWrapper.style.display = 'grid';
      
      citiesWrapper.innerHTML = '';
      allCities.slice(0, initialCount).forEach(city => {
        citiesWrapper.innerHTML += createCityHTML(city, window.cityStoresMap[city]);
      });

      document.querySelectorAll('.store-other-city__link').forEach(function(city, index){
        city.addEventListener('click', function(e){
          gaEvent('spot_your_city', [index + 1, this.getAttribute('data-city'), '', '', '', ''], false);
        })
      })
      
      setTimeout(() => {
        attachCityClickHandlers();
      }, 100);
    }
  }

  function createCityHTML(city, cityStores) {
    const isLongName = city.length > 12;
    const dataLongAttr = isLongName ? 'data-long="true"' : '';
    
    // Get the first store's pincode and URL from the new data structure
    const firstStorePincode = cityStores && cityStores.length > 0 ? cityStores[0].pincode : '';
    const triggerPincodeAttr = firstStorePincode ? `data-triggerpincode="${firstStorePincode}"` : '';
    
    // Only use the storeUrl from the API
    const cityUrl = cityStores && cityStores.length > 0 && cityStores[0].cityUrl ? cityStores[0].cityUrl : '#';
    
    // Get the store count for this city
    const storeCount = cityStores ? cityStores.length : 0;
    
    const fallbackImageSvg = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
      <svg width="130" height="130" xmlns="http://www.w3.org/2000/svg">
        <rect width="130" height="130" fill="#1A2A58"/>
        <text x="50%" y="50%" font-family="Arial, sans-serif" font-size="14" font-weight="bold" fill="#FFFFFF" text-anchor="middle" dy=".3em">${city}</text>
      </svg>
    `)}`;
    
    return `
      <div class="store-other-city__item dev_store-other-city__item" ${triggerPincodeAttr} data-city-url="${cityUrl}">
        <a href="${cityUrl}" class="store-other-city__link" data-city="${city}">
          <div class="store-other-city__image-wrapper">
            <img src="https://cdn.shopify.com/s/files/1/0635/6929/7637/files/${city.toLowerCase().replace(/\s+/g, '-')}-city-img.jpg" 
                 alt="${city} city image" 
                 loading="lazy"
                 class="store-other-city__image"
                 onerror="this.src='${fallbackImageSvg}'">
          </div>
          <div class="store-other-city__name" ${dataLongAttr}><div>${city}</div> <div class="store-other-city__count">(${storeCount} Store${storeCount !== 1 ? 's' : ''})</div> </div>

        </a>
      </div>
    `;
  }

  function toggleCityView() {
    const viewAllBtn = document.getElementById('viewAllCitiesBtn');
    
    const viewAllText = viewAllBtn.dataset.viewAllText || 'VIEW ALL CITIES';
    const collapseText = viewAllBtn.dataset.collapseText || 'SHOW LESS';
    
    if (!isShowingAll) {
      loadCities(true);
      viewAllBtn.textContent = collapseText;
      isShowingAll = true;
    } else {
      loadCities(false);
      viewAllBtn.textContent = viewAllText;
      isShowingAll = false;
    }
  }

  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (!isShowingAll) {
        loadCities(false);
      }
    }, 250);
  });
});